export const ROLES = {
  USER: 1,
  RESELLER: 2,
  ADMIN: 99,
};

const ROLE_LABELS = {
  [ROLES.USER]: 'User',
  [ROLES.RESELLER]: 'Reseller',
  [ROLES.ADMIN]: 'Admin',
};

const ROLE_COLORS = {
  [ROLES.USER]:     { bg: '#1f2937', color: '#9ca3af' },
  [ROLES.RESELLER]: { bg: '#1c3a2a', color: '#6ee7b7' },
  [ROLES.ADMIN]:    { bg: '#3b1a1a', color: '#fca5a5' },
};

export function roleLabel(level) {
  return ROLE_LABELS[level] ?? `Role ${level}`;
}

export function roleBadgeStyle(level) {
  const c = ROLE_COLORS[level] ?? { bg: '#374151', color: '#d1d5db' };
  return {
    display: 'inline-block',
    padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600,
    background: c.bg, color: c.color,
  };
}
